import {
    debounce,
    loadSvg,
} from '../common/utils';

const els = {
    $cursor: () => $('[data-cursor]'),
};

const TRANSITION_DURATION = 0.25;

const styleForVideo = () => {

    const $cursor = els.$cursor();

    if ($cursor.hasClass('cursor--video')) {
        return;
    }

    const svg = loadSvg('play');

    gsap.set(
        $cursor,
        {
            autoAlpha: 0,
            scale: 0,
        }
    );

    $cursor
        .empty()
        .removeClass()
        .addClass('cursor cursor--video')
        .append(`
            <div class="cursor__inner">
                <div class="cursor__text">play video</div>
                <div class="cursor__icon">
                    ${svg}
                </div>
            </div>
        `);

    gsap.to(
        $cursor,
        {
            autoAlpha: 1,
            scale: 1,
            duration: TRANSITION_DURATION,
        }
    );
};

const styleForDefault = () => {

    const $cursor = els.$cursor();

    $cursor
        .empty()
        .removeClass()
        .addClass('cursor');

    gsap.to(
        $cursor,
        {
            autoAlpha: 0,
            rotate: 0,
            scale: 1,
            duration: TRANSITION_DURATION,
        }
    );
};

const handleMouseMove = (event) => {

	const $cursor = $('[data-cursor]');

    gsap.set(
        $cursor,
        {
            top: event.clientY - $cursor.height() / 2,
            left: event.clientX - $cursor.width() / 2,
        }
    );
};

const handleMouseMoveVideo = () => {

    styleForVideo();
};

const handleMouseLeaveVideo = () => {

    styleForDefault();
};

const prepare = () => {

    $(window).on('mousemove.cursor', handleMouseMove);

    $('[data-use-video-cursor]').each((_, element) => {

        $(element)
            .on('mousemove.cursor', handleMouseMoveVideo)
            .on('mouseleave.cursor', handleMouseLeaveVideo);

    });
};

const cleanUp = () => {

    $(window).off('mousemove.cursor');

    $('[data-use-video-cursor]').each((_, element) => {

        $(element)
            .off('mousemove.cursor')
            .off('mouseleave.cursor');

    });
};

const initialize = () => {

    prepare();

    $(window).resize(
        debounce(
            () => {
                cleanUp();
                prepare();
            },
            100
        )
    );
};

export default {
    initialize,
    styleForDefault,
};

